import { all, fork } from 'redux-saga/effects';
import {
    watchFindStoresRequest,
    watchFindMoreStoresRequest,
    // eslint-disable-next-line import/no-unresolved
} from 'yoda-site-components/lib/sagas/FindStoresSaga';
import watchOptInRequest from './OptInSaga';
import watchIrisHamburgerChange from './IrisHamburgerSaga';
import IrisGlobalNavigationSaga from './IrisGlobalNavigationSaga';
import {
    watchUserStoreLocationInfo,
    watchUpdateUserStoreLocationInfo,
    watchUpdateNativeFavouriteStore,
    watchSaveNativeFavoriteStore,
} from './LocationServiceSaga';
import StickyTimerSaga from './StickyTimerSaga';
import LocationSaga from './LocationSaga';
import IrisPromotionalBannerSaga from './IrisPromotionalBannerSaga';
import SetMyDefaultStoreSaga from './SetMyDefaultStoreSaga';
import watchPasswordResetSaga from './PasswordResetSaga';
import CreateAccountSaga from './CreateAccountSaga';
import watchSignInSaga from './SigninSaga';
import watchPhoneVerification from './PhoneVerificationSaga';
import watchPLCCBannerSaga from './PLCCBannerSaga';
import watchSessionsRequest from './SessionSaga';
import watchPromotionalBannerActionRequest from './PromotionalBannerSaga';
import watchStoreSagaActionsRequest, { watchSetMyStore } from './StoreSaga';
import watchAccessTokenProviderRequest from './AccessTokenProviderSaga';
import watchAccountRequest from './AccountSaga';
import watchUrgencyMessagingSaga from './UrgencyMessagingSaga';
import watchAppointmentSaga from './AppointmentSaga';
import watchApplySyfSaga from './ApplySyfSaga';
import watchVendorActionsSaga from './VendorActionsSaga';
import watchWeeklyAdsSaga from './WeeklyAdsSaga';
import watchIrisBannerShopZoneRequest from './IrisBannerShopZoneSaga';
import watchRewardsSaga from './RewardsSaga';
import nativeAppSaga from './NativeAppSaga';
import clientLoggerSaga from './ClientLoggerSaga';
import IrisGlobalFooterNavigationSaga from './IrisGlobalFooterNavigationSaga';
import watchRevieveAddToCartSaga from './RevieveAddToCartSaga';
import nativeAppsUserDetailsSaga from './NativeAppUserDetailsSaga';
import NativeStoresByLatLongSaga from './NativeStoresByLatLongSaga';
import watchSavedItem from './SavedItemsSaga';

const sagas = {
    /**
     * Native feature
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-checkout-components/src/sagas/PayWithAppleSaga.js
     * yoda-checkout-components/src/components/OrderSummary/OrderSummaryCTA.jsx
     * yoda-microsite-cart/src/components/EmptyCart/EmptyCart.jsx
     * yoda-microsite-checkout/src/sagas/OrderConfirmationSaga.js
     * yoda-microsite-checkout/src/sagas/CartDetailsSaga.js
     * yoda-microsite-cart/src/sagas/CartDetailsSaga.js
     * yoda-checkout-components/src/sagas/AddToCartInterstitialSaga.js
     * yoda-site-components/src/sagas/FactorySaga.js
     */
    nativeAppSaga,
    /**
     * Header - session
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    watchSessionsRequest,
    /**
     * Cart/Checkout/PDP - store info
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-cart/src/containers/Pages/GiftCard/GiftCardBalance.jsx
     * yoda-microsite-cart/src/sagas/CartDetailsSaga.js
     * yoda-microsite-checkout/src/containers/Pages/OrderConfirmation/OrderConfirmationPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/sagas/NewShippingSaga.js
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    watchStoreSagaActionsRequest,
    /**
     * Native code - access token
     * yoda-site-components/src/sagas/FactorySaga.js
     */
    watchAccessTokenProviderRequest,
    /**
     * header - promo banner
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * IRIS component "textbanner"
     */
    watchPromotionalBannerActionRequest,
    /**
     * account component
     * yoda-microsite-account/src/App.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-site-components/src/sagas/SigninSaga.js
     * yoda-microsite-account/src/sagas/AccountDetailsSaga.js
     * yoda-microsite-checkout/src/sagas/CreateAccountPostOrderSaga.js
     */
    watchAccountRequest,
    /**
     * Cart/Checkout/PDP - store info
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-cart/src/containers/Pages/GiftCard/GiftCardBalance.jsx
     * yoda-microsite-cart/src/sagas/CartDetailsSaga.js
     * yoda-microsite-checkout/src/containers/Pages/OrderConfirmation/OrderConfirmationPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/sagas/NewShippingSaga.js
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    watchSetMyStore,
    /**
     * Password reset
     * yoda-site-components/src/externalize/Common/Components.js
     */
    watchPasswordResetSaga,
    /**
     * create account
     * yoda-microsite-cart/src/containers/Pages/SignIn/components/CreateAccountButton/CreateAccountButton.jsx
     * yoda-microsite-account/src/App.jsx
     * yoda-site-components/src/externalize/Common/Components.js
     * yoda-microsite-rewards/src/containers/Pages/LaunchNLearn/LaunchNLearn.jsx
     */
    CreateAccountSaga,
    /**
     * sign in
     * Refer to https://wiki.jcpenney.com/display/DIGPLAT/MYODACORE-428.+Abandoned+Reducers+and+Sagas.+Review+yoda-site-components
     * for SignInSaga details
     */
    watchSignInSaga,
    /**
     * urgency message
     * yoda-microsite-listing/src/common/CustomAddToCart/CustomAddToCart.jsx
     * yoda-microsite-listing/src/components/Lists/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     */
    watchUrgencyMessagingSaga,
    /**
     * set up appointment
     * yoda-microsite-account/src/components/Appointments/Appointments.jsx
     * yoda-microsite-marketing/src/containers/Pages/Barbery/Barbery.jsx
     * yoda-microsite-marketing/src/containers/Pages/Meevo/Meevo.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     */
    watchAppointmentSaga,
    /**
     * apply syf
     * yoda-microsite-rewards/src/containers/Pages/ApplySyf/ApplySyf.jsx
     * yoda-microsite-account/src/components/BarcodeEdit/subComponents/NoCardItem.jsx
     * yoda-microsite-rewards/src/containers/Pages/LaunchNLearn/LaunchNLearn.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsRedesign/Rewards.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsLegacy/RewardsLegacy.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/Orders.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingList.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPage.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboard.jsx
     * yoda-site-components/src/externalize/Common/Components.js
     */
    watchApplySyfSaga,
    /**
     * phne verification
     * yoda-microsite-account/src/components/ProfileSettings/MyDetails/MyDetails.jsx
     * yoda-microsite-cart/src/containers/Pages/SignIn/components/CreateAccountButton/CreateAccountButton.jsx
     * yoda-microsite-account/src/App.jsx
     * yoda-site-components/src/externalize/Common/Components.js
     * yoda-site-components/src/externalize/Common/Components.js
     */
    watchPhoneVerification,
    /**
     * vendor
     * yoda-microsite-cart/src/containers/Pages/SignIn/SignInPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/AccountLocked/AccountLockedPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    watchVendorActionsSaga,
    /**
     * iris banner shope zone
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx - /findastore page
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     */
    watchIrisBannerShopZoneRequest,
    /**
     * weekly ads
     * yoda-site-components/src/components/YodaHeader/Header.jsx under flag enableHeaderStoreMenuSlider
     */
    watchWeeklyAdsSaga,
    /**
     * plcc banner
     * yoda-site-components/src/externalize/Common/Components.js
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsRedesign/Rewards.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsLegacy/RewardsLegacy.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/Orders.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingList.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPage.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboard.jsx
     * yoda-site-components/src/sagas/SigninSaga.js
     * yoda-microsite-account/src/sagas/PaymentMethodsSaga.js  - saga exists out of site-components
     */
    watchPLCCBannerSaga,
    /**
     * hamburger
     * yoda-site-components/src/components/YodaHeader/Header.jsx under enableHybridHamburger
     * yoda-site-components/src/components/MobileBotHamburger/MobileBotHamburger.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx
     */
    watchIrisHamburgerChange,
    /**
     * navigation menu
     * yoda-site-components/src/components/YodaHeader/Header.jsx under !disableVisualNavSSR
     * yoda-site-components/src/components/YodaHeaderOld/Header.jsx under !disableVisualNavSSR
     * yoda-microsite-gallery/src/AmpComponents/AMPSiteComponents/Hamburger/Hamburger.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx under context.isNative
     */
    IrisGlobalNavigationSaga,
    /**
     * user store location
     * yoda-microsite-pdp/src/sagas/AddToCartSaga.js  - saga exists out of site-components
     * yoda-microsite-pdp/src/sagas/UpdateCartSaga.js  - saga exists out of site-components
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx under enableLocationService
     */
    watchUserStoreLocationInfo,
    /**
     * To update store infomation to location service saga
     * yoda-microsite-pdp/src/sagas/AddToCartSaga.js
     * yoda-microsite-pdp/src/sagas/UpdateCartSaga.js
     */
    watchUpdateUserStoreLocationInfo,
    watchUpdateNativeFavouriteStore,
    watchSaveNativeFavoriteStore,
    /**
     * sticky timer
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-site-components/src/components/StickyTimer/StickyTimer.jsx
     */
    StickyTimerSaga,
    /**
     * location
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    LocationSaga,
    /**
     * cart, pdp, checkout - find store component
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx
     */
    watchFindStoresRequest,
    /**
     * cart, pdp, checkout - find store component
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx
     */
    watchFindMoreStoresRequest,
    /**
     * promo banner
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * IRIS component "textbanner" (home, department, coupon)
     */
    IrisPromotionalBannerSaga,
    /**
     * set my store
     * yoda-microsite-account/src/App.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-site-components/src/sagas/SigninSaga.js
     */
    SetMyDefaultStoreSaga,
    /**
     * update rewards in storage when signed in
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    watchRewardsSaga,
    /**
     * optin
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-gallery/src/containers/Pages/Gallery/GalleryDesktop.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     * yoda-site-components/src/components/YodaFooter/components/FooterLinks/index.jsx
     */
    watchOptInRequest,
    clientLoggerSaga,
    /**
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     */
    IrisGlobalFooterNavigationSaga,
    watchRevieveAddToCartSaga,
    /* yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx */
    nativeAppsUserDetailsSaga,
    watchSavedItem,
    /* yoda-site-components/lib/components/LocationFinder/LocationFinder.jsx */
    NativeStoresByLatLongSaga,
};

const siteComponentSagas = function* siteComponentSagas() {
    yield all(Object.values(sagas).map((saga) => fork(saga)));
};

siteComponentSagas.injectedSagas = sagas;

export default siteComponentSagas;
